<template>
  <section class="cabinet-prizes">
    <div class="cabinet-header _mb-8">
      <div class="cabinet-header__text _mr-4 _mr-sm-0 _mb-sm-8">
        <div class="_mb-4 _fs-24 _lh-32 _fw-700 _tc-dark">
          {{ $t("cabinet.dashboard.sections[1].title") }}
        </div>
        <div class="_fs-16 _lh-24">
          {{ $t("cabinet.dashboard.sections[1].descr") }}
        </div>
        <a
          class="_fs-16 _lh-24 _mt-2 _tc-green-second"
          href="/content/rules.pdf"
          target="_blank"
          >Условия</a
        >
      </div>
      <div class="cabinet-header__stat _ml-4 _ml-sm-0">
        <div class="cabinet-header__stat-el _mr-8 _mr-sm-7">
          <div class="cabinet-header__icon _mr-4">
            <img :src="require('@/assets/img/cabinet/coins_icon.png')" />
          </div>
          <div class="cabinet-header__num">
            <div class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _fw-600 _tc-dark">
              {{ user.balance }}
            </div>
            <div class="_fs-16 _fs-sm-14 _lh-24 _lh-sm-20 _tc-dark">
              {{ $tc("cabinet.dashboard.cards[1].tip", user.balance) }}
            </div>
          </div>
        </div>
        <div class="cabinet-header__stat-el">
          <div class="cabinet-header__icon _mr-4">
            <img :src="require('@/assets/img/cabinet/cup_icon.png')" />
          </div>
          <div
            class="cabinet-header__num"
            v-if="
              Achievements &&
              Achievements.achievements &&
              Achievements.achievements.captured >= 0
            "
          >
            <div class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _fw-600 _tc-dark">
              {{ Achievements.achievements.captured }}
            </div>
            <div class="_fs-16 _fs-sm-14 _lh-24 _lh-sm-20 _tc-dark">
              {{
                $tc(
                  "cabinet.dashboard.cards[2].tip",
                  Achievements.achievements.captured
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="cabinet-prizes__block _mb-8"
      v-if="
        Achievements &&
        Achievements.achievements &&
        Achievements.achievements.captured >= 0
      "
    >
      <div class="_mb-6 _fs-24 _lh-32 _fw-700 _tc-dark">
        {{ $t("cabinet.dashboard.sections[1].prizeTitle") }}
      </div>
      <div class="cabinet-prizes__list">
        <div
          class="cabinet__card cabinet__card-one _br--2 _px-8 _py-8 _px-sm-4"
        >
          <div class="_fs-20 _fs-sm-16 _lh-24 _tc-dark _fw-700">
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].title[0]") }}
          </div>
          <div
            class="cabinet__card-status _mt-2 _fs-14 _fs-sm-14 _lh-20 _tc-dark _mb-auto"
            v-if="
              UserPrizes && UserPrizes.find((el) => el.slug === 'stickerpack')
            "
          >
            <svg
              class="_mr-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="8" fill="#77BB2F" />
              <path
                d="M12.6654 5L6.2487 10.5L3.33203 8"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].descrUnlock") }}
          </div>
          <div
            class="cabinet__card-status _mt-2 _fs-16 _fs-sm-14 _lh-26 _tc-dark _mb-auto"
            v-else
          >
            <svg
              class="_mr-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_3793_117466)">
                <path
                  d="M7.9987 5.3335V8.00016M7.9987 10.6668H8.00536M14.6654 8.00016C14.6654 11.6821 11.6806 14.6668 7.9987 14.6668C4.3168 14.6668 1.33203 11.6821 1.33203 8.00016C1.33203 4.31826 4.3168 1.3335 7.9987 1.3335C11.6806 1.3335 14.6654 4.31826 14.6654 8.00016Z"
                  stroke="#DC8633"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_3793_117466">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Обменивайте коины на призы
          </div>
          <div
            class="d-flex"
            v-if="
              UserPrizes && !UserPrizes.find((el) => el.slug === 'stickerpack')
            "
          >
            <span class="_fs-24 _fw-500 _lh-32 _mr-2">200</span>
            <img
              class="_my-auto"
              width="32"
              height="32"
              :src="require('@/assets/img/leaderboard/coins.png')"
            />
          </div>
          <AppBtn
            class="_mt-4"
            :btnClass="'btn_orange'"
            v-if="
              UserPrizes && UserPrizes.find((el) => el.slug === 'stickerpack')
            "
          >
            <a
              href="https://t.me/addstickers/Herbalife_Academy"
              target="_blank"
              class="cabinet-prizes__btn _tc-white _fs-16 _lh-24"
            >
              {{
                $t("cabinet.dashboard.sections[1].prizeCards[0].downloadBtn")
              }}
              <svg
                class="_ml-2"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          </AppBtn>
          <AppBtn
            class="_mt-3"
            @click.native="buyPrize('stickerpack', 200)"
            :btnClass="'btn_orange'"
            v-else
          >
            <span class="cabinet-prizes__btn _tc-white _fs-16 _lh-24">
              Обменять коины
            </span>
          </AppBtn>
          <picture>
            <source
              :srcset="require('@/assets/img/cabinet/herby-1(375).png')"
              media="(max-width: 743px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/herby-1(768).png')"
              media="(max-width: 1220px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/herby-1.png')"
              media="(max-width: 9999999px)"
            />
            <img
              :src="require('@/assets/img/cabinet/herby-1.png')"
              alt="img"
              class="cabinet__card-img cabinet__card-one_img"
            />
          </picture>
        </div>
        <div
          class="cabinet__card cabinet__card-two _br--2 _px-8 _py-8 _px-sm-4"
        >
          <div class="_fs-20 _fs-sm-16 _lh-24 _tc-dark _fw-700">
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].title[1]") }}
          </div>
          <div
            class="cabinet__card-status _mt-2 _fs-14 _fs-sm-14 _lh-20 _tc-dark _mb-auto"
            v-if="
              UserPrizes && UserPrizes.find((el) => el.slug === 'wallpaper')
            "
          >
            <svg
              class="_mr-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="8" fill="#77BB2F" />
              <path
                d="M12.6654 5L6.2487 10.5L3.33203 8"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].descrUnlock") }}
          </div>
          <div
            class="cabinet__card-status _mt-2 _fs-14 _fs-sm-14 _lh-20 _tc-dark _mb-auto"
            v-else
          >
            <svg
              class="_mr-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_3793_117466)">
                <path
                  d="M7.9987 5.3335V8.00016M7.9987 10.6668H8.00536M14.6654 8.00016C14.6654 11.6821 11.6806 14.6668 7.9987 14.6668C4.3168 14.6668 1.33203 11.6821 1.33203 8.00016C1.33203 4.31826 4.3168 1.3335 7.9987 1.3335C11.6806 1.3335 14.6654 4.31826 14.6654 8.00016Z"
                  stroke="#DC8633"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_3793_117466">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            Обменивайте коины на призы
          </div>
          <div
            class="d-flex"
            v-if="
              UserPrizes && !UserPrizes.find((el) => el.slug === 'wallpaper')
            "
          >
            <span class="_fs-24 _fw-500 _lh-32 _mr-2">300</span>
            <img
              class="_my-auto"
              width="32"
              height="32"
              :src="require('@/assets/img/leaderboard/coins.png')"
            />
          </div>
          <AppBtn
            class="_mt-3"
            :btnClass="'btn_orange'"
            v-if="
              UserPrizes && UserPrizes.find((el) => el.slug === 'wallpaper')
            "
          >
            <a
              href="/content/wallpaper.zip"
              download
              class="cabinet-prizes__btn _tc-white _fs-16 _lh-24"
            >
              {{
                $t("cabinet.dashboard.sections[1].prizeCards[0].downloadBtn")
              }}
              <svg
                class="_ml-2"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          </AppBtn>
          <AppBtn
            class="_mt-3"
            :btnClass="'btn_orange'"
            @click.native="buyPrize('wallpaper', 300)"
            v-else
          >
            <span class="cabinet-prizes__btn _tc-white _fs-16 _lh-24">
              Обменять коины
            </span>
          </AppBtn>
          <picture>
            <source
              :srcset="require('@/assets/img/cabinet/card-img_1(375).png')"
              media="(max-width: 743px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/card-img_1(768).png')"
              media="(max-width: 1220px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/card-img_1.png')"
              media="(max-width: 9999999px)"
            />
            <img
              :src="require('@/assets/img/cabinet/card-img_1.png')"
              alt="img"
              class="cabinet__card-img cabinet__card-two_img"
            />
          </picture>
        </div>
        <div
          class="cabinet__card cabinet__card-three _br--2 _px-8 _py-8 _px-sm-4"
        >
          <div class="_fs-20 _fs-sm-16 _lh-24 _tc-dark _fw-700">
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].title[2]") }}
          </div>
          <div
            class="cabinet__card-status _mt-2 _fs-14 _fs-sm-14 _lh-20 _tc-dark _mb-auto"
            v-if="UserPrizes && UserPrizes.find((el) => el.slug === 'zoom')"
          >
            <svg
              class="_mr-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="8" fill="#77BB2F" />
              <path
                d="M12.6654 5L6.2487 10.5L3.33203 8"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].descrUnlock") }}
          </div>
          <div
            class="cabinet__card-status _mt-2 _fs-14 _fs-sm-14 _lh-20 _tc-dark _mb-auto"
            v-else
          >
            <svg
              class="_mr-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_3793_117466)">
                <path
                  d="M7.9987 5.3335V8.00016M7.9987 10.6668H8.00536M14.6654 8.00016C14.6654 11.6821 11.6806 14.6668 7.9987 14.6668C4.3168 14.6668 1.33203 11.6821 1.33203 8.00016C1.33203 4.31826 4.3168 1.3335 7.9987 1.3335C11.6806 1.3335 14.6654 4.31826 14.6654 8.00016Z"
                  stroke="#DC8633"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_3793_117466">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            Обменивайте коины на призы
          </div>
          <div
            class="d-flex"
            v-if="UserPrizes && !UserPrizes.find((el) => el.slug === 'zoom')"
          >
            <span class="_fs-24 _fw-500 _lh-32 _mr-2">400</span>
            <img
              class="_my-auto"
              width="32"
              height="32"
              :src="require('@/assets/img/leaderboard/coins.png')"
            />
          </div>
          <AppBtn
            class="_mt-3"
            :btnClass="'btn_orange'"
            v-if="UserPrizes && UserPrizes.find((el) => el.slug === 'zoom')"
          >
            <a
              href="/content/zoom.zip"
              download
              class="cabinet-prizes__btn _tc-white _fs-16 _lh-24"
            >
              {{
                $t("cabinet.dashboard.sections[1].prizeCards[0].downloadBtn")
              }}
              <svg
                class="_ml-2"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          </AppBtn>
          <AppBtn
            class="_mt-3"
            :btnClass="'btn_orange'"
            @click.native="buyPrize('zoom', 400)"
            v-else
          >
            <span class="cabinet-prizes__btn _tc-white _fs-16 _lh-24">
              Обменять коины
            </span>
          </AppBtn>
          <picture>
            <source
              :srcset="require('@/assets/img/cabinet/card-img_2(375).png')"
              media="(max-width: 743px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/card-img_2(768).png')"
              media="(max-width: 1220px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/card-img_2.png')"
              media="(max-width: 9999999px)"
            />
            <img
              :src="require('@/assets/img/cabinet/card-img_2.png')"
              alt="img"
              class="cabinet__card-img cabinet__card-three_img"
            />
          </picture>
        </div>
        <div
          class="cabinet__card cabinet__card-four _br--2 _px-8 _py-8 _px-sm-4"
          v-if="false"
        >
          <div class="_fs-20 _fs-sm-16 _lh-24 _tc-dark _fw-700">
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].title[3]") }}
          </div>
          <div
            class="cabinet__card-status _mt-2 _fs-14 _fs-sm-14 _lh-20 _tc-dark _mb-auto"
            v-if="UserPrizes && UserPrizes.find((el) => el.slug === 'cutaway')"
          >
            <svg
              class="_mr-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="8" fill="#77BB2F" />
              <path
                d="M12.6654 5L6.2487 10.5L3.33203 8"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].descrUnlock") }}
          </div>
          <div
            class="cabinet__card-status _mt-2 _fs-14 _fs-sm-14 _lh-20 _tc-dark _mb-auto"
            v-else
          >
            <svg
              class="_mr-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_3793_117466)">
                <path
                  d="M7.9987 5.3335V8.00016M7.9987 10.6668H8.00536M14.6654 8.00016C14.6654 11.6821 11.6806 14.6668 7.9987 14.6668C4.3168 14.6668 1.33203 11.6821 1.33203 8.00016C1.33203 4.31826 4.3168 1.3335 7.9987 1.3335C11.6806 1.3335 14.6654 4.31826 14.6654 8.00016Z"
                  stroke="#DC8633"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_3793_117466">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            Обменивайте коины на призы
          </div>
          <div
            class="d-flex"
            v-if="UserPrizes && !UserPrizes.find((el) => el.slug === 'cutaway')"
          >
            <span class="_fs-24 _fw-500 _lh-32 _mr-2">500</span>
            <img
              class="_my-auto"
              width="32"
              height="32"
              :src="require('@/assets/img/leaderboard/coins.png')"
            />
          </div>
          <AppBtn
            class="_mt-3"
            :btnClass="'btn_orange'"
            v-if="UserPrizes && UserPrizes.find((el) => el.slug === 'cutaway')"
            @click.native="openCutaway()"
          >
            <span class="cabinet-prizes__btn _tc-white _fs-16 _lh-24">
              {{ $t("cabinet.dashboard.sections[1].prizeCards[0].soonBtn") }}
              <svg
                class="_ml-2"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </AppBtn>
          <AppBtn
            class="_mt-3 cabinet-prizes__btn-locked"
            :btnClass="'btn_orange'"
            @click.native="openCutaway()"
            v-else
          >
            <span class="cabinet-prizes__btn _tc-white _fs-16 _lh-24">
              {{ $t("cabinet.dashboard.sections[1].prizeCards[0].soonBtn") }}
              <svg
                class="_ml-2"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </AppBtn>
          <picture>
            <source
              :srcset="require('@/assets/img/cabinet/card-img_3(375).png')"
              media="(max-width: 743px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/card-img_3(768).png')"
              media="(max-width: 1220px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/card-img_3.png')"
              media="(max-width: 9999999px)"
            />
            <img
              :src="require('@/assets/img/cabinet/card-img_3.png')"
              alt="img"
              class="cabinet__card-img cabinet__card-four_img"
            />
          </picture>
        </div>
      </div>
    </div>
    <div v-if="user.status && user.status !== 'Привилегированный клиент'">
      <div class="_mb-6" v-if="false">
        <div class="_mb-4 _fs-24 _lh-32 _fw-700 _tc-dark">
          {{ $t("cabinet.dashboard.sections[1].prizeByTitle") }}
        </div>
        <div class="_fs-18 _lh-28 _fw-500">
          {{ $t("cabinet.dashboard.sections[1].prizeByDescr") }}
        </div>
      </div>
      <div v-if="false" class="cabinet__links _mt-md-8">
        <div
          class="cabinet__card cabinet__links-form _mr-4 _mr-sm-0 _mb-md-0 _mb-sm-8 _br--2 _px-6 _py-6 _px-sm-4"
        >
          <div class="cabinet__card-top">
            <div class="cabinet__card-icon _mr-2">
              <img :src="require('@/assets/img/cabinet/phone-icon.jpg')" />
            </div>
            <div class="d-flex">
              <div class="_fs-20 _lh-24 _fw-700 _tc-dark">
                {{ $t("cabinet.dashboard.sections[1].prizeCards[1].title[4]") }}
              </div>
            </div>
          </div>
          <div
            class="d-flex _my-4 _tc-green-second"
            style="cursor: pointer"
            @click="modalToggle('rulesModal', true)"
          >
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].rulesPopup") }}
            <svg
              class="_my-auto _ml-2"
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_3676_99243)">
                <path
                  d="M6.375 6C6.375 5.40326 6.65156 4.83097 7.14384 4.40901C7.63613 3.98705 8.30381 3.75 9 3.75H9.75C10.4462 3.75 11.1139 3.98705 11.6062 4.40901C12.0984 4.83097 12.375 5.40326 12.375 6C12.4026 6.48694 12.2713 6.96967 12.0007 7.37548C11.7302 7.78129 11.3351 8.08821 10.875 8.25C10.4149 8.46572 10.0198 8.87494 9.74928 9.41602C9.47874 9.9571 9.34738 10.6007 9.375 11.25"
                  stroke="#629727"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M9.375 14.25V14.2575"
                  stroke="#629727"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </g>
              <rect
                x="1.125"
                y="0.75"
                width="16.5"
                height="16.5"
                rx="8.25"
                stroke="#629727"
                stroke-width="1.5"
              ></rect>
              <defs>
                <clipPath id="clip0_3676_99243">
                  <rect
                    x="0.375"
                    width="18"
                    height="18"
                    rx="9"
                    fill="white"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="cabinet__card-descr _mt-4 _fs-16 _lh-24">
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].descrPKK") }}
          </div>
          <div class="_mt-8">
            <AppBtn
              class="_mr-auto w-100 w-md-auto"
              :btnClass="`${
                disableCoinTransfer ? 'btn_inactive' : ''
              } btn_orange`"
              @click.native="coinsFormToggle()"
              :disabled="disableCoinTransfer"
            >
              <span
                class="_tc-white _fs-16 _lh-24 _py-2 _py-sm-3 _px-4 _px-xs-0"
              >
                {{ $t("cabinet.dashboard.sections[1].prizeCards[0].formBtn") }}
              </span>
            </AppBtn>
            <div v-if="disableCoinTransfer" class="_mt-4 _fs-16 _lh-24">
              Ваша заявка успешно отправлена на рассмотрение. <br />Повторное
              создание станет доступно после рассмотрения существующей заявки.
            </div>
          </div>
        </div>
        <div
          class="cabinet__card cabinet__links-prize _ml-4 _ml-sm-0 _br--2 _px-6 _py-6 _px-sm-4"
        >
          <div class="cabinet__card-top">
            <div class="cabinet__card-icon _mr-2">
              <img :src="require('@/assets/img/cabinet/prize-icon.jpg')" />
            </div>
            <div class="_fs-20 _lh-24 _fw-700 _tc-dark">
              {{ $t("cabinet.dashboard.sections[1].prizeCards[1].title[5]") }}
            </div>
          </div>
          <div class="cabinet__card-descr _mt-4 _fs-16 _lh-24">
            {{ $t("cabinet.dashboard.sections[1].prizeCards[1].descrSelect") }}
          </div>
          <div class="_mt-8">
            <AppBtn class="_mr-auto w-100 w-md-auto" :btnClass="'btn_orange'">
              <a
                href="http://prk.herbalife.ru/"
                class="_tc-white _fs-16 _lh-24 _py-2 _py-sm-3 _px-4 _px-xs-0"
              >
                {{ $t("cabinet.dashboard.sections[1].prizeCards[0].linkBtn") }}
              </a>
            </AppBtn>
          </div>
        </div>
      </div>
      <div
        v-if="CoinsStat && CoinsStat.length"
        class="referal__table-title _mt-16 _mb-16 _fs-32 _fs-sm-24 _lh-38 _fw-700 _tc-dark"
      >
        История конвертации коинов в баллы
      </div>
      <div v-if="CoinsStat && CoinsStat.length" class="_mt-md-16 _mt-0">
        <div class="referal__table">
          <div
            class="referal__table-item"
            v-for="(item, i) in CoinsStat"
            :key="i"
          >
            <div
              class="_fs-20 _fs-sm-16 _lh-24 _fw-400 _tc-dark-gray referal__table-item-check"
            >
              <div
                class="referal__table-item-check"
                :data-head="'Дата конвертации'"
              >
                {{ formatDate(item.created_at) }}
              </div>
            </div>
            <div
              class="referal__table-item-coins _mr-12 _mr-sm-0"
              :data-head="'Коины'"
            >
              <img :src="require('@/assets/img/leaderboard/coins.png')" />
              <div class="referal__table-item-coins-count">
                <span class="_fs-20 _fs-sm-16 _lh-24 _fw-400 _tc-dark-gray">{{
                  item.coins_requested
                }}</span>
              </div>
            </div>
            <!-- <div class="referal__table-item-container"> -->
            <div class="">
              <div class="referal__table-item-check" :data-head="'Статус'">
                <span
                  v-if="item.status == 'На рассмотрении'"
                  class="_fw-600 _tc-orange"
                  >На рассмотрении</span
                >
                <span
                  v-if="item.status == 'Рассмотрена'"
                  class="_fw-600 _tc-orange"
                  >Рассмотрена<br />
                  <span class="_tc-grey _fs-13 _fw-400">
                    (данные отправлены в ПРК)</span
                  >
                </span>
                <span
                  v-else-if="item.status == 'Одобрена'"
                  class="_fw-600 _tc-green"
                  >Заявка одобрена<br />
                  <span class="_tc-grey _fs-13 _fw-400">
                    (ожидайте поступление баллов в ПРК)</span
                  >
                </span>
                <span
                  v-else-if="item.status === 'Отклонена'"
                  class="_fw-600 _tc-red"
                  >Заявка отклонена
                </span>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <Modal v-if="fillForm" @close="modalToggle('fillForm', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div class="_mb-8">
            <div class="_fs-20 _lh-24 _fw-700 _tc-dark _mb-2">
              {{ $t("modals.prizesForm.card_form_title") }}
            </div>
            <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
              {{ $t("modals.prizesForm.description") }}
            </div>
            <div class="_fs-16 _lh-24 _tc-green-second _mb-8">
              {{ $t("modals.prizesForm.tip") }}
            </div>
            <div class="_mb-8">
              <v-input
                :class="{ '_mb-10': !secondName.state }"
                class="_mb-4 w-100"
                v-model="secondName.value"
                :state="secondName.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.surname')"
                :state-invalid-text="secondName.error"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
              <v-input
                :class="{ '_mb-10': !cutaway_name.state }"
                class="_mb-4 w-100"
                v-model="cutaway_name.value"
                :state="cutaway_name.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.name') + '*'"
                :state-invalid-text="cutaway_name.error"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>

              <v-input
                :class="{ '_mb-10': !cutaway_lastName.state }"
                class="_mb-4 w-100"
                v-model="cutaway_lastName.value"
                :state="cutaway_lastName.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.lastname')"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
            </div>

            <div class="d-md-flex d-block justify-start align-start">
              <div class="d-md-flex d-block justify-start align-start">
                <div class="d-flex _mr-4 _mb-6 _mr-sm-0 w-100">
                  <v-input
                    :class="{ '_mb-10': !cutaway_phone.state }"
                    class="w-100"
                    v-model="cutaway_phone.value"
                    :state="cutaway_phone.state ? null : false"
                    :state-invalid-text="cutaway_phone.error"
                    label-style="label-border"
                    :label="$t('fields_labels.phone')"
                  >
                    <template v-slot:clear>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L1 13M1 1L13 13"
                          stroke="#B2B4B2"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </template>
                  </v-input>
                </div>
                <div class="_ml-4 _ml-sm-0 _mb-6 w-100">
                  <v-input
                    :class="{ '_mb-10': !cutaway_email.state }"
                    class="_mb-4 w-100"
                    v-model="cutaway_email.value"
                    :state="cutaway_email.state ? null : false"
                    label-style="label-border"
                    label="Email"
                    :state-invalid-text="cutaway_email.error"
                  >
                    <template v-slot:clear>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L1 13M1 1L13 13"
                          stroke="#B2B4B2"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </template>
                  </v-input>
                </div>
              </div>
            </div>
            <v-input
              :class="{ '_mb-10': !cutaway_description.state }"
              style="height: 100px; max-height: 100px"
              class="_mb-4 w-100"
              v-model="cutaway_description.value"
              :state="cutaway_description.state ? null : false"
              label-style="label-border"
              :label="$t('fields_labels.soc_link')"
              :placeholder="$t('fields_labels.soc_link')"
              :state-invalid-text="cutaway_description.error"
              @change="validateDescription()"
              @blur="validateDescription()"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
            <div
              class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey"
              :style="`color: ${validSocial ? '' : '#dc582a'}`"
            >
              Отметьте социальные сети где вас можно найти*
            </div>
            <div class="d-md-flex d-block justify-start align-start">
              <label class="checkbox__container _mr-4 _mb-sm-4">
                <div class="checkbox__toggler">
                  <input
                    type="checkbox"
                    v-model="cutaway_soc_link.value"
                    :value="'vk'"
                  />
                  <svg
                    width="27"
                    height="26"
                    viewBox="0 0 27 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      width="26"
                      height="26"
                      rx="8"
                      fill="#77BB2F"
                    />
                    <rect
                      width="16"
                      height="16"
                      transform="translate(5.5 5)"
                      fill="#77BB2F"
                    />
                    <path
                      d="M18.8327 9L11.4993 16.3333L8.16602 13"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="checkbox__label">Вконтакте</div>
              </label>
              <label class="checkbox__container _mr-4 _mb-sm-4">
                <div class="checkbox__toggler">
                  <input
                    type="checkbox"
                    v-model="cutaway_soc_link.value"
                    :value="'tg'"
                  />
                  <svg
                    width="27"
                    height="26"
                    viewBox="0 0 27 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      width="26"
                      height="26"
                      rx="8"
                      fill="#77BB2F"
                    />
                    <rect
                      width="16"
                      height="16"
                      transform="translate(5.5 5)"
                      fill="#77BB2F"
                    />
                    <path
                      d="M18.8327 9L11.4993 16.3333L8.16602 13"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="checkbox__label">Телеграмм</div>
              </label>
              <label class="checkbox__container">
                <div class="checkbox__toggler">
                  <input
                    type="checkbox"
                    v-model="cutaway_soc_link.value"
                    :value="'ok'"
                  />
                  <svg
                    width="27"
                    height="26"
                    viewBox="0 0 27 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      width="26"
                      height="26"
                      rx="8"
                      fill="#77BB2F"
                    />
                    <rect
                      width="16"
                      height="16"
                      transform="translate(5.5 5)"
                      fill="#77BB2F"
                    />
                    <path
                      d="M18.8327 9L11.4993 16.3333L8.16602 13"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="checkbox__label">Одноклассники</div>
              </label>
            </div>
          </div>
          <div
            class="d-flex justify-between align-center _mt-8 direction-column-reverse direction-lg-row"
          >
            <AppBtn
              class="w-100 w-md-auto _mx-auto"
              @click.native="sendToMail()"
            >
              <span class="_fs-16 _lh-24 _py-3 _py-sm-3 _px-4 _px-xs-0">
                {{ $t("modals.prizesForm.mailsend") }}
              </span>
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-if="coinsForm" @close="coinsFormToggle()">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div class="_mb-8">
            <div class="_fs-20 _lh-24 _fw-700 _tc-dark _mb-2">
              {{ $t("cabinet.dashboard.sections[1].priseModals[0].title") }}
            </div>
            <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
              {{ $t("cabinet.dashboard.sections[1].priseModals[0].subtitle") }}
            </div>
            <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
              {{ $t("cabinet.dashboard.sections[1].priseModals[0].descr") }}
            </div>
            <!-- <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
              <div class="d-flex">
                <div class="_mr-2" style="flex-shrink: 0">
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4998 6.66675V10.0001M10.4998 13.3334H10.5082M18.8332 10.0001C18.8332 14.6025 15.1022 18.3334 10.4998 18.3334C5.89746 18.3334 2.1665 14.6025 2.1665 10.0001C2.1665 5.39771 5.89746 1.66675 10.4998 1.66675C15.1022 1.66675 18.8332 5.39771 18.8332 10.0001Z"
                      stroke="#DC8633"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                Максимальное количество коинов для перевода =&nbsp;1000
              </div>
            </div> -->
            <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
              <div class="d-flex">
                <div class="_mr-2" style="flex-shrink: 0">
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4998 6.66675V10.0001M10.4998 13.3334H10.5082M18.8332 10.0001C18.8332 14.6025 15.1022 18.3334 10.4998 18.3334C5.89746 18.3334 2.1665 14.6025 2.1665 10.0001C2.1665 5.39771 5.89746 1.66675 10.4998 1.66675C15.1022 1.66675 18.8332 5.39771 18.8332 10.0001Z"
                      stroke="#DC8633"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                Минимальный порог вывода =&nbsp;200 коинов
              </div>
            </div>
            <div class="_fs-16 _lh-24 _tc-green-second _mb-8">
              {{ $t("cabinet.dashboard.sections[1].priseModals[0].tip") }}
            </div>
            <div class="_mb-8">
              <v-input
                :class="{ '_mb-10': !name.state }"
                :readonly="true"
                class="_mb-4 w-100"
                v-model="name.value"
                :state="name.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.name') + '*'"
                :state-invalid-text="name.error"
                @change="validate(['name'])"
                @blur="validate(['name'])"
                @click.native="changeFieldAlert()"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
              <v-input
                :class="{ '_mb-10': !secondName.state }"
                :readonly="true"
                class="_mb-4 w-100"
                v-model="secondName.value"
                :state="secondName.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.surname')"
                :state-invalid-text="secondName.error"
                @change="validate(['secondName'])"
                @blur="validate(['secondName'])"
                @click.native="changeFieldAlert()"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
              <!-- <v-input
                :class="{ '_mb-10': !lastName.state }"
                class="_mb-4 w-100"
                v-model="lastName.value"
                :state="lastName.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.lastname')"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input> -->
              <div class="d-md-flex align-start">
                <v-input
                  :class="{ '_mb-10': !PRK_id.state }"
                  :readonly="true"
                  class="_mb-4 _mr-7 _mr-xs-0 w-100"
                  v-model="PRK_id.value"
                  :state="PRK_id.state ? null : false"
                  label-style="label-border"
                  :label="
                    $t('cabinet.dashboard.sections[1].priseModals[0].pkkId')
                  "
                  :state-invalid-text="PRK_id.error"
                  @change="validate(['PRK_id'])"
                  @blur="validate(['PRK_id'])"
                  @click.native="changeFieldAlert()"
                >
                  <template v-slot:clear>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13 1L1 13M1 1L13 13"
                        stroke="#B2B4B2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </template>
                </v-input>
                <v-input
                  :class="{ '_mb-10': !country.state }"
                  :readonly="true"
                  class="_mb-4 w-100"
                  v-model="country.value"
                  :state="country.state ? null : false"
                  label-style="label-border"
                  :label="
                    $t('cabinet.dashboard.sections[1].priseModals[0].country')
                  "
                  :state-invalid-text="country.error"
                  @change="validate(['country'])"
                  @blur="validate(['country'])"
                  @click.native="changeFieldAlert()"
                >
                  <template v-slot:clear>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13 1L1 13M1 1L13 13"
                        stroke="#B2B4B2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </template>
                </v-input>
              </div>
              <v-input
                :class="{ '_mb-10': !coins.state }"
                class="_mb-4 w-100"
                v-model="coins.value"
                :state="coins.state ? null : false"
                label-style="label-border"
                :label="
                  $t('cabinet.dashboard.sections[1].priseModals[0].coinCount')
                "
                :state-invalid-text="coins.error"
                @change="validateBalance"
                @blur="validateBalance"
                type="number"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
            </div>
          </div>
          <div
            class="d-flex justify-between align-center _mt-8 direction-column-reverse direction-lg-row"
          >
            <AppBtn class="w-100 w-md-auto" @click.native="coinsFormTransfer()">
              <span class="_fs-16 _lh-24 _py-3 _py-sm-3 _px-4 _px-xs-0">
                {{ $t("cabinet.dashboard.sections[1].priseModals[0].sendBtn") }}
              </span>
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-if="rulesModal" @close="modalToggle('rulesModal', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div class="_fs-20 _lh-24 _fw-700 _tc-dark _mb-4">
            {{ $t("cabinet.dashboard.sections[1].priseModals[1].title") }}
          </div>
          <div
            v-html="
              $t('cabinet.dashboard.sections[1].priseModals[1].containText')
            "
          ></div>
        </div>
      </template>
    </Modal>
    <Modal
      v-if="coinsSuccess"
      :custom-class="'congrat-modal_horizontal _pt-10 _pl-0'"
      @close="modalToggle('coinsSuccess', false)"
    >
      <template #modalBody>
        <CongratModal :is-vertical="false">
          <template>
            <div class="_mr-5 _mr-sm-0 _mb-sm-5 _mt-sm-4 congrat-modal__img">
              <img :src="require('@/assets/img/cabinet/herby-prizes.png')" />
            </div>
            <div>
              <div class="_mb-4">
                <h2
                  class="congrat-modal__title _fs-24 _lh-32 _fw-700"
                  :class="{ 'text-center': false }"
                >
                  Ваша заявка принята!
                </h2>
              </div>
              <div class="_mb-8">
                <p
                  class="congrat-modal__txt _fs-16 _lh-24 _fw-500"
                  :class="{ 'text-center': false }"
                >
                  Баллы зачислятся после 15 {{ month }}.
                  <br />
                  <br />
                  Как только баллы по данной заявке появятся на ПРК, вы сможете
                  подать новую заявку.
                </p>
              </div>

              <AppBtn
                class="_py-2 _px-5 _mx-sm-auto"
                @click.native="modalToggle('coinsSuccess', false)"
              >
                <div>
                  <p>Закрыть</p>
                </div>
              </AppBtn>
            </div>
          </template>
        </CongratModal>
      </template>
    </Modal>
  </section>
</template>

<script>
import AppBtn from "../../components/UI/buttons/AppBtn.vue";
// import Progress from '../../components/UI/intensives/Progress.vue'
import Modal from "@/components/UI/Modal";
import validate from "@/mixins/validate";
import CongratModal from "@/components/gamification/CongratModal.vue";
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";
export default {
  metaInfo() {
    return { title: this.$t("cabinet.dashboard.menu[2]") };
  },
  name: "CabinetPrizes",
  components: {
    AppBtn,
    // Progress,
    CongratModal,
    Modal,
  },
  mixins: [validate],
  data: () => ({
    linkCopied: false,
    rulesModal: false,
    fillForm: false,
    coinsForm: false,
    coinsSuccess: false,
    validSocial: true,
    cutaway_name: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters"],
    },
    cutaway_secondName: {
      value: "",
      state: true,
      error: "",
    },
    cutaway_lastName: {
      value: "",
      state: true,
      error: "",
    },
    cutaway_email: {
      value: "",
      state: true,
      error: "",
      rules: ["isCorrectEmail"],
    },
    cutaway_phone: {
      value: "",
      state: true,
      error: "",
      rules: ["isCorrectPhone"],
    },
    cutaway_soc_link: {
      value: [],
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    cutaway_description: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    name: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    secondName: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    lastName: {
      value: "",
      state: true,
      error: "",
    },
    PRK_id: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    coins: {
      value: "",
      state: true,
      error: "",
      rules: ["aliquot", "moreThan"],
    },
    country: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    email: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "isCorrectEmail"],
    },
    phone: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "isCorrectPhone"],
    },
    address: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    soc_link: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
  }),
  computed: {
    ...mapGetters([
      "Rules",
      "user",
      "Achievements",
      "CoinsStat",
      "UserPrizes",
      "ServerTime",
    ]),
    maskString() {
      return `(###) ### - ## - ##`;
    },
    month() {
      let month =
        new Date(this.ServerTime.server_time).getMonth() + 1 > 11
          ? 0
          : new Date(this.ServerTime.server_time).getMonth() + 1;
      return this.$t(`interface.monthsNoun[${month}]`);
    },
    disableBtn() {
      return /^80X/.test(this.user.username) || /^79X/.test(this.user.username);
    },
    disableCoinTransfer() {
      return (
        this.CoinsStat &&
        this.CoinsStat.length > 0 &&
        this.CoinsStat[0].status !== "Одобрена" &&
        this.CoinsStat[0].status !== "Отклонена"
      );
    },
  },
  methods: {
    ...mapActions([
      "fetchChangeUserData",
      "fetchAlerts",
      "fetchCoinsExchange",
      "fetchAchievements",
      "SOCKET_SEND_MESSAGE",
      "fetchCoinsStat",
      "fetchUserPrizes",
      "buyUserPrize",
      "fetchServerTime",
    ]),
    validateBalance() {
      if (this.coins.value > this.user.balance) {
        this.$set(this.coins, "state", false);
        this.$set(this.coins, "error", "На вашем балансе недостаточно коинов");
        return;
      }
      this.validate(["coins"]);
    },
    buyPrize(slug, price) {
      if (price > this.user.balance) {
        this.fetchAlerts({
          alerts: "Недостаточно коинов",
          type: "error",
        });

        return;
      }
      this.buyUserPrize(slug);
    },
    changeFieldAlert() {
      this.fetchAlerts({
        alerts: "Изменить эти данные можно только в Личном кабинете",
        type: "error",
      });
    },
    validateDescription() {
      this.cutaway_description.state = !!this.Rules.maxLength(
        this.cutaway_description.value,
        false,
        45
      );
      this.$set(
        this.cutaway_description,
        "error",
        this.Rules.maxLength(this.cutaway_description.value, false, 45)
          ? ""
          : "Не больше 45 символов"
      );
      return this.cutaway_description.state;
    },
    copyReferralLink() {
      var copyText =
        window.location.origin + "/register/" + this.user.referral_code;
      navigator.clipboard.writeText(copyText);
      this.linkCopied = true;
      setTimeout(() => {
        this.linkCopied = false;
      }, 2000);
    },
    validateSocial() {
      this.$set(this, "validSocial", !!this.cutaway_soc_link.value.length);
      setTimeout(() => {
        this.$set(this, "validSocial", true);
      }, 1000);
      return !!this.cutaway_soc_link.value.length;
    },
    sendToMail() {
      if (
        this.validate(["cutaway_name"]) &&
        this.validateDescription() &&
        this.validateSocial()
      ) {
        this.modalToggle("fillForm", false);
      }
    },
    modalToggle(modal, state) {
      this[modal] = state;
      bus.$emit("scrollLock", state);
    },
    openCutaway() {
      if (this.user.is_internal) {
        this.modalToggle("fillForm", true);
      } else {
        this.fetchAlerts({
          alerts: "Призы будут доступны позже",
          type: "notify",
        });
      }
    },
    formatDate(dateString) {
      if (!dateString) {
        return "";
      }
      let date = new Date(dateString);
      return `${date.getDate().toString().padStart(2, 0)}.${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, 0)}.${date.getFullYear()}`;
    },
    async coinsFormTransfer() {
      let balanceEnough = this.coins.value <= this.user.balance;
      if (
        balanceEnough &&
        this.validate(["name", "secondName", "PRK_id", "coins", "country"])
      ) {
        const coinsTransfer = await this.fetchCoinsExchange({
          coins_requested: this.coins.value,
          first_name: this.name.value,
          last_name: this.secondName.value,
          third_party_user_id: this.PRK_id.value,
          country: this.country.value,
        });
        if (coinsTransfer) {
          // this.fetchAlerts({
          //   alerts: 'Ваша заявка на перевод коинов успешно отправлена',
          //   type: 'notify',
          // })
          this.modalToggle("coinsSuccess", true);
          await this.fetchCoinsStat();
          this.coinsForm = !this.coinsForm;
        }
      }
    },
    coinsFormToggle() {
      if (!this.disableCoinTransfer) {
        this.coinsForm = !this.coinsForm;
      } else {
        this.modalToggle("rulesModal", true);
      }
    },
  },
  async mounted() {
    await this.fetchAchievements();
    await this.fetchCoinsStat();
    await this.fetchUserPrizes();
    await this.fetchServerTime();
    if (this.user && Object.keys(this.user).length) {
      this.name.value = this.user.first_name;
      this.secondName.value = this.user.last_name;
      this.PRK_id.value = this.user.username;
      this.country.value = this.user.ds_mailing_country;
    }
    this.SOCKET_SEND_MESSAGE(
      JSON.stringify({
        action: "set_path",
        path: this.$router.resolve({
          name: this.$route.name.replace("Loc", ""),
        }).href,
      })
    );
  },
};
</script>
<style lang="scss" scoped>
:deep(.congrat-modal_vertical) {
  max-width: 495px;
}

.congrat-modal {
  &__title {
    color: color(dark);

    @media screen and (max-width: 767px) {
      text-align: center;
    }
  }

  &__txt {
    color: color(dark-grey);

    @media screen and (max-width: 767px) {
      text-align: center;
    }
  }

  &__img {
    min-height: 216px;
    max-height: 100%;
    height: 1px;

    @media screen and (max-width: 767px) {
      height: 250px;
    }

    & img {
      height: 100%;
      object-fit: scale-down;
    }
  }
}
</style>

<style lang="scss" scoped>
.cabinet {
  &-prizes {
    &__list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 24px 32px;
      @media screen and (max-width: 1220px) {
        grid-template-columns: 1fr;
      }
      .cabinet__card {
        width: 100%;
        max-height: 320px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (max-width: 743px) {
        }
      }
    }
    &__btn {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 7px 12px;
      &-locked {
        pointer-events: none;
        opacity: 0.4;
      }
    }
  }
  &-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media screen and (max-width: 1220px) {
      align-items: flex-end;
    }
    @media screen and (max-width: 743px) {
      flex-direction: column;
      align-items: flex-start;
    }
    &__text {
      width: 50%;
      flex-shrink: 0;
      @media screen and (max-width: 743px) {
        width: 100%;
      }
    }
    &__stat {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-el {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    &__icon {
      width: 100px;
      height: 100px;
      border: 1px solid #d1d2cd;
      border-radius: 99px;
      @media screen and (max-width: 1220px) {
        width: 74px;
        height: 74px;
      }
      @media screen and (max-width: 743px) {
        width: 60px;
        height: 60px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }
  &-descr {
    width: 50%;
    @media screen and (max-width: 743px) {
      width: 100%;
    }
  }
  &__links {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    @media screen and (max-width: 1220px) {
      // display: block;
    }

    @media screen and (max-width: 743px) {
      display: block;
    }
  }
  &__card {
    width: 50%;
    min-height: 320px;
    border: 1px solid #d1d2cd;
    position: relative;
    @media screen and (max-width: 1220px) {
      // height: 320px;
    }
    @media screen and (max-width: 743px) {
      height: auto;
      width: 100%;
    }
    &-one {
      background-color: #f4e5c0;
      &_img {
        position: absolute;
        top: 50px;
        right: 30px;
        @media screen and (max-width: 1220px) {
          top: 20px;
          right: 50px;
        }
        @media screen and (max-width: 743px) {
          top: auto;
          right: 45px;
          bottom: 32px;
        }
      }
    }
    &-two {
      background-color: #ebf6e3;
      &_img {
        position: absolute;
        top: auto;
        bottom: 30px;
        right: 35px;
        @media screen and (max-width: 1220px) {
          right: 75px;
        }
        @media screen and (max-width: 743px) {
          right: 45px;
          bottom: 32px;
        }
      }
    }
    &-three {
      background-color: #eef3f7;
      &_img {
        position: absolute;
        top: auto;
        bottom: 30px;
        right: 35px;
        @media screen and (max-width: 1220px) {
          right: 50px;
        }
        @media screen and (max-width: 743px) {
          right: 28px;
          bottom: 32px;
        }
      }
    }
    &-four {
      background-color: #b8e2fe;
      &_img {
        position: absolute;
        top: auto;
        bottom: 30px;
        right: 35px;
        @media screen and (max-width: 1220px) {
          right: 50px;
        }
        @media screen and (max-width: 743px) {
          right: 28px;
          bottom: 32px;
        }
      }
    }
    &-top {
      height: 62px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
    }
    &-icon {
      height: 62px;
      width: 60px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .card__text {
      @media screen and (max-width: 743px) {
        position: relative;
        z-index: 2;
        height: 100%;
        display: flex;
        // flex-direction: column;
      }
    }
    &-status {
      display: flex;
      align-items: center;
      @media screen and (max-width: 743px) {
        max-width: 255px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.referal {
  &__table {
    &-item {
      padding: 15px 30px;
      background: #ffffff;
      border: 1px solid #77bb2f;
      border-radius: 16px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      justify-content: flex-start;
      align-items: center;
      min-height: 87px;
      margin-bottom: 8px;
      column-gap: 32px;

      @media screen and (max-width: 1220px) {
        grid-template-columns: 1fr 1fr 1fr;
      }

      @media screen and (max-width: 767px) {
        padding: 16px;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: repeat(2, auto);
        gap: 0;
        row-gap: 16px;
        align-items: flex-start;
      }

      &-number {
        position: relative;
        // width: 63px;
        height: 45px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 767px) {
          display: flex;

          &::before {
            position: static;
            margin-right: 8px;
            width: auto !important;
          }
        }
      }

      &-date {
        position: relative;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "Noto-Sans", sans-serif;
        font-style: normal;
        // font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        // color: #54585a;
        &::before {
          left: 50% !important;
          transform: translateX(-50%) !important;
        }
        @media screen and (max-width: 1220px) {
          justify-content: flex-start;
        }
        @media screen and (max-width: 767px) {
          margin-left: 0;
          display: block;
        }
      }

      &-container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 1220px) {
          grid-template-columns: 1fr 1fr 1fr;
        }
      }

      &-check {
        height: 45px;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &::before {
          @media screen and (max-width: 767px) {
            text-align: left;
          }
        }
        @media screen and (max-width: 767px) {
          margin: 0;
          display: block;
          grid-column-start: 1;
          grid-column-end: 3;
          height: auto;
        }
        & img {
          width: 45px;
          margin-right: 8px;
          @media screen and (max-width: 767px) {
            width: 20px;
          }
        }
        &-count {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 28px;
          height: 28px;
          background: #ffffff;
          padding: 8px;
          border-radius: 50%;
          border: 1px solid #c7c9c7;
          font-family: "Noto-Sans", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          text-align: center;
          color: #25282a;
          @media screen and (max-width: 767px) {
            margin-right: 8px;
            padding: 0;
            border-radius: 0;
            background: transparent;
            border: 0;
            width: auto;
            height: auto;
            font-size: 12px;
            line-height: 12px;

            text-align: left;

            color: #629727;
          }
        }

        &-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          justify-content: flex-start;
          align-items: center;
        }
      }

      &-coins {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 1220px) {
          justify-content: flex-start;
        }
        @media screen and (max-width: 767px) {
          height: 45px;
          flex-wrap: wrap;
        }
        & img {
          width: 45px;
          margin-right: 8px;
          @media screen and (max-width: 767px) {
            width: 26px;
          }
        }
        &-count {
          font-family: "Noto-Sans", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          color: #54585a;
          @media screen and (max-width: 767px) {
            color: #629727;
          }
        }
      }

      &:first-child {
        & *[data-head] {
          &::before {
            display: block;
            white-space: nowrap;
            @media screen and (max-width: 1220px) {
              top: -55px;
              width: 100%;
            }
          }
        }
      }
      & *[data-head] {
        &::before {
          position: absolute;
          top: -60px;
          left: 0;
          display: none;
          font-family: "Noto-Sans", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #b2b4b2;
          content: attr(data-head) "";
          @media screen and (max-width: 767px) {
            display: block;
            position: static;
            width: 100%;
            transform: none !important;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
